/**
 * Atualiza o preenchimento da barra de progresso de frete gratis quando o
 * carrinho muda (drawer ou pagina /cart), com base no evento "cart:change"
 * que o tema ja dispara a cada atualizacao de carrinho.
 */
(function () {
  'use strict';

  function setProgress(el, totalPriceCents) {
    var fill = el.querySelector('.free-shipping-progress__fill');
    if (!fill) { return; }
    var thresholdCents = parseFloat(el.getAttribute('data-threshold-cents')) || 0;
    var percent = thresholdCents > 0 ? Math.min(100, (totalPriceCents / thresholdCents) * 100) : 100;
    fill.style.width = percent + '%';
    el.classList.toggle('is-complete', percent >= 100);
  }

  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) { return; }

    var priceForItems = cart.items
      .filter(function (item) { return item.requires_shipping; })
      .reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    var cartDiscount = (cart.cart_level_discount_applications || [])
      .reduce(function (sum, discount) { return sum + discount.total_allocated_amount; }, 0);
    var totalPriceCents = priceForItems - cartDiscount;

    document.querySelectorAll('[data-free-shipping-progress]').forEach(function (el) {
      setProgress(el, totalPriceCents);
    });
  });
})();
